import React, { useEffect, useState } from 'react';
import { useNightMode } from '../../contexts/NightModeContext';
const Background: React.FC = () => {
  const { isNightMode } = useNightMode();
  const [isLight, setIsLight] = useState(!isNightMode);

  useEffect(() => {
    setIsLight(!isNightMode);
  }, [isNightMode]);

  useEffect(() => {
    const update = () => {
      const hasNight = document.documentElement.classList.contains('night-mode');
      const hasLight = document.body.classList.contains('light-theme');
      setIsLight(!hasNight || hasLight);
    };
    update();

    const observer = new MutationObserver(update);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  const baseStyle: React.CSSProperties = isLight
    ? {
        backgroundColor: '#e7e7e7',
        backgroundImage:
          'radial-gradient(at 90% 10%, rgba(238, 63, 124, 0.05) 0px, transparent 65%),' +
          'radial-gradient(at 10% 90%, rgba(238, 63, 124, 0.02) 0px, transparent 60%),' +
          'radial-gradient(at 50% 50%, #e7e7e7 0px, transparent 100%)',
      }
    : {
        backgroundColor: '#060609',
        backgroundImage:
          'radial-gradient(at 90% 10%, rgba(238, 63, 124, 0.16) 0px, transparent 65%),' +
          'radial-gradient(at 10% 90%, rgba(158, 27, 79, 0.12) 0px, transparent 60%),' +
          'radial-gradient(at 50% 50%, rgba(6, 6, 9, 1) 0px, transparent 100%)',
      };

  const blob1Style: React.CSSProperties = {
    top: '-15%',
    right: '-10%',
    width: '45vw',
    height: '45vw',
    minWidth: 380,
    minHeight: 380,
    background: isLight
      ? 'radial-gradient(circle, rgba(238, 63, 124, 0.14) 0%, transparent 70%)'
      : 'radial-gradient(circle, rgba(238, 63, 124, 0.35) 0%, transparent 70%)',
    filter: 'blur(90px)',
    opacity: isLight ? 0.6 : 0.9,
  };

  const blob2Style: React.CSSProperties = {
    bottom: '-15%',
    left: '-10%',
    width: '40vw',
    height: '40vw',
    minWidth: 340,
    minHeight: 340,
    background: isLight
      ? 'radial-gradient(circle, rgba(247, 155, 89, 0.1) 0%, transparent 70%)'
      : 'radial-gradient(circle, rgba(247, 155, 89, 0.25) 0%, transparent 70%)',
    filter: 'blur(90px)',
    opacity: isLight ? 0.5 : 0.8,
  };

  return (
    <>
      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{ ...baseStyle, zIndex: -2, pointerEvents: 'none', transition: 'background-color 0.3s ease, background-image 0.3s ease' }}
      />
      <div
        className="position-fixed rounded-circle"
        style={{ ...blob1Style, zIndex: -1, pointerEvents: 'none', transition: 'opacity 0.3s ease, background 0.3s ease' }}
      />
      <div
        className="position-fixed rounded-circle"
        style={{ ...blob2Style, zIndex: -1, pointerEvents: 'none', transition: 'opacity 0.3s ease, background 0.3s ease' }}
      />
    </>
  );
};

export default Background;